export const withdrawRequestDrawer = {
	title: "Solicitar retiro o pago de boleta",
	titleWithdraw: "Solicitar retiro",
	titleBankslip: "Pago de boleta",
	titlePendingBankslip: "Pago de boleta Zig",
	pendingBankslip: "Boleta pendiente",
	warning: "Solo valores hasta el saldo disponible para retiro pueden ser solicitados.",
	withdrawOption: "Retiro",
	anticipationOption: "Anticipación",
	bankslipPaymentOption: "Pago de boleta",
	bankSlid: {
		bankSlipValue: "Valor de la boleta",
		bankSlipInfo: "Información de la boleta",
		dataReview: "Revisión de los datos",
		form: {
			liquidValue: "Valor neto",
			liquidValuePlaceholder: "Ingrese aquí el valor neto",
			beneficiary: "Beneficiario",
			barCode: "Número del código de barras",
			dueDate: "Vencimiento",
			attachment: "Seleccionar archivo de la boleta",
			valuesReview: "Revisión de los valores",
			bankSlipValue: "Valor de la boleta",
			available: "Saldo disponible para retiro",
			liquidAmmountRequested: "Valor neto solicitado",
			thidPartyWithdrawFee: "Tarifa de retiro para terceros",
			totalValue: "Valor bruto total",
			bankSlipInfo: "Información de la boleta",
			calculating: "Calculando...",
		},
		transactionDetails: {
			title: "Detalle de la transacción",
			paymentValue: "Valor del pago",
			available: "Valor de retiro",
			totalValue: "Valor total",
			calculating: "Calculando...",
		},
	},
	withdraw: {
		withdrawValue: "Valor del retiro",
		accountInfo: "Información de la cuenta",
		dataReview: "Revisión de los datos",
		warning:
			"Solicitudes realizadas después de las 10h30 (horario de Brasilia) solo serán atendidas al día siguiente.",
		warningAccountChoice:
			"Se cobrará una tarifa de {{value}} para retiro en cuentas de terceros.",
		errorMessage: "No fue posible completar la solicitud.",
		successMessage: "¡Retiro solicitado con éxito!",
		liquidValue: "Valor neto",
		liquidValuePlaceholder: "Ingrese aquí el valor neto",
		reason: "Motivo de la solicitud",
		reasonPlaceholder: "Ingrese aquí el motivo para el retiro",
		account: "Cuenta",
		accountPlaceholder: "Escriba o seleccione la cuenta",
	},
	titleTransfer: "Transferir saldo entre places",
	transferOption: "Transferencia entre places",
	bankslipValue: "Valor de la boleta",
	expireDate: "Vencimiento",
	downloadBankslipPdf: "Descargar boleta en PDF",
};
